import { render, staticRenderFns } from "./AwemeMonitor.vue?vue&type=template&id=1d85ec1d&scoped=true"
import script from "./AwemeMonitor.vue?vue&type=script&lang=js"
export * from "./AwemeMonitor.vue?vue&type=script&lang=js"
import style0 from "./AwemeMonitor.vue?vue&type=style&index=0&id=1d85ec1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85ec1d",
  null
  
)

export default component.exports